import React from "react";
import { useLang, useSettings } from "../lib/providers";
import { MessageCircle, Mail } from "lucide-react";

export default function Contact() {
  const { lang } = useLang();
  const { settings } = useSettings();

  const waDz = (settings.whatsapp_dz || "").replace(/\D/g, "");
  const waFr = (settings.whatsapp_fr || settings.contact_phone_fr || "").replace(/\D/g, "");
  const email = settings.contact_email || "";

  if (!waDz && !waFr && !email) return null;

  const lDz = lang === "ar" ? settings.contact_whatsapp_dz_label_ar : settings.contact_whatsapp_dz_label_fr;
  const lFr = lang === "ar" ? settings.contact_whatsapp_fr_label_ar : settings.contact_whatsapp_fr_label_fr;

  return (
    <section id="contact" className="py-16 sm:py-20 theme-section-alt" data-testid="contact-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-[11px] font-bold tracking-[0.25em] uppercase text-neon mb-3">Contact</p>
        <h2 className="font-heading font-black uppercase tracking-tighter text-3xl sm:text-4xl mb-8">
          {lang === "ar" ? "اتصل بي مباشرة" : "Contactez-moi directement"}
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {waDz && (
            <a href={`https://wa.me/${waDz}`} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white px-5 py-3 font-heading font-black uppercase tracking-widest text-sm hover:opacity-90 transition-opacity"
              data-testid="contact-wa-dz">
              <MessageCircle className="w-4 h-4" /> {lDz || "WhatsApp Algérie"}
            </a>
          )}
          {waFr && (
            <a href={`https://wa.me/${waFr}`} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 border border-white/20 text-white px-5 py-3 font-heading font-black uppercase tracking-widest text-sm hover:bg-white/5 transition-colors"
              data-testid="contact-wa-fr">
              <MessageCircle className="w-4 h-4" /> {lFr || "WhatsApp France"}
            </a>
          )}
          {email && (
            <a href={`mailto:${email}`}
              className="inline-flex items-center gap-2 border border-white/20 text-white px-5 py-3 font-heading font-black uppercase tracking-widest text-sm hover:bg-white/5 transition-colors"
              data-testid="contact-email">
              <Mail className="w-4 h-4" /> Email
            </a>
          )}
        </div>
        {/* Phone numbers are NEVER displayed in cleartext to the public per requirement */}
      </div>
    </section>
  );
}
